import * as React from "react";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useAppStore from "../../stores/appStore";
import {
  selectedAssistantSelector
} from "../../stores/selectors/appSelectors";
import {
  clearCollectionBreadCrumbsSelector,
  collectionBreadCrumbsLastItemSelector,
  collectionBreadCrumbsSelector,
  ignoreUrlChangeSelector,
  removeLastItemFromCollectionBreadCrumbsSelector,
  selectedCollectionSelector,
  setIgnoreUrlChangeSelector,
  setSelectedCollectionSelector
} from "src/stores/selectors/collectionsSelectors";
import { ASSISTANT_CHANNELS, CHANNEL_SETTINGS, HOME } from "@consts";
import { capitalize, capitalizeAndCleanUnderscore } from "@utils";
import { SETTINGS_CONFIG } from "src/components/collections/consts";
import HyroBreadcrumbs from "@hyro-components/hyro-breadcrumbs/HyroBreadcrumbs";

const CollectionBreadcrumbs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { accountId, assistantId } = useParams();
  const selectedAssistant = useAppStore(selectedAssistantSelector);
  const selectedCollection = useAppStore(selectedCollectionSelector);
  const setSelectedCollection = useAppStore(setSelectedCollectionSelector);
  const collectionBreadCrumbs = useAppStore(collectionBreadCrumbsSelector);
  const removeLastItemFromCollectionBreadCrumbs = useAppStore(removeLastItemFromCollectionBreadCrumbsSelector);
  const collectionBreadCrumbsLastItem = useAppStore(collectionBreadCrumbsLastItemSelector);
  const clearCollectionBreadCrumbs = useAppStore(clearCollectionBreadCrumbsSelector);
  const ignoreUrlChange = useAppStore(ignoreUrlChangeSelector);
  const setIgnoreUrlChange = useAppStore(setIgnoreUrlChangeSelector);
  const baseUrl = `/${accountId}/${assistantId}/`;
  const pageName = location.pathname.replace(baseUrl, "")?.split("/")?.[0];
  const isOnSettingsPage = location.pathname.endsWith(CHANNEL_SETTINGS);

  let settingsConfigObject;

  if (isOnSettingsPage && selectedAssistant) {
    settingsConfigObject = selectedAssistant.channel === ASSISTANT_CHANNELS.WEB ? SETTINGS_CONFIG.CHAT : SETTINGS_CONFIG.VOICE;
  }

  const pathName = selectedCollection?.display_key || settingsConfigObject?.display_key;
  const breadcrumbs = [
    capitalize(selectedAssistant?.name).replace(/[_-]/, " "),
    capitalize(pageName).replace(/[_-]/, " "),
    ...(pathName ? [capitalizeAndCleanUnderscore(pathName)] : [])
  ];

  const handleBackClick = () => {
    const lastItem = collectionBreadCrumbsLastItem;
    removeLastItemFromCollectionBreadCrumbs();
    setIgnoreUrlChange(true);
    navigate(lastItem?.url);
  };

  useEffect(() => {
    const currentUrl = location.pathname;

    if (collectionBreadCrumbs.length === 0) {
      return;
    }
    const lastItemUrl = collectionBreadCrumbsLastItem?.url;

    if (currentUrl !== lastItemUrl && !ignoreUrlChange) {
      clearCollectionBreadCrumbs();
    }
    setIgnoreUrlChange(false);

  }, [location]);

  if (!selectedAssistant) {
    return null;
  }

  return (
    <HyroBreadcrumbs
      breadcrumbs={breadcrumbs}
      baseUrl={baseUrl}
      onBreadcrumbClick={() => setSelectedCollection(null)}
      backButton={collectionBreadCrumbs.length > 0 ?
        `Back to ${collectionBreadCrumbsLastItem?.collection} - ${collectionBreadCrumbsLastItem?.name}` :
        null}
      onBackClick={handleBackClick}
    />
  );
};

export default CollectionBreadcrumbs;
